const RoundDown = (value1, value2) => {
  const factor = Math.pow(10, 1);
  if (value1 && value2) {
    return Math.floor(Number(value1 / value2) * factor) / factor;
  }
  return Math.floor(Number(value1) * factor) / factor;
};

export default RoundDown;
